"use client"

import { ThreeDMarquee } from "@/components/common/3d-marquee/3d-marquee";
import {
  ImgMarquee1,
  ImgMarquee2,
  ImgMarquee3,
  ImgMarquee4,
  ImgMarquee5,
  ImgMarquee6,
  ImgMarquee7,
  ImgMarquee8,
} from "@/lib/images";
import React, { useEffect, useState } from "react";

function shuffleArray<T>(array: T[]): T[] {
  return [...array].sort(() => Math.random() - 0.5);
}

const staticImages1 = [
    ImgMarquee1,
    ImgMarquee2,
    ImgMarquee3,
    ImgMarquee4,
    ImgMarquee5,
    ImgMarquee6,
    ImgMarquee7,
    ImgMarquee8,
];

const staticImages2 = [
    ImgMarquee5,
    ImgMarquee6,
    ImgMarquee7,
    ImgMarquee8,
    ImgMarquee1,
    ImgMarquee2,
    ImgMarquee3,
    ImgMarquee4,
];

export default function SideMarqueeSectionPoweringProducts() {
  const [columns, setColumns] = useState([staticImages1, staticImages2]);

  useEffect(() => {
    setColumns([shuffleArray(staticImages1), shuffleArray(staticImages2)]);
  }, []);

  return (
    <div className="lg:flex hidden">
      <ThreeDMarquee
        columns={columns}
        wrapperClassName="w-[1450px] scale-[0.45] sm:scale-[0.65] lg:scale-[1] 2xl:scale-[1.5]"
        gridClassName="grid origin-top-center grid-cols-8 xl:grid-cols-6 gap-6 transform"
        gridStyle={{ transform: "rotateX(0deg) rotateY(0deg) rotateZ(10deg)" }}
      />
    </div>
  );
}
